// extracted by mini-css-extract-plugin
export var active = "_1s-9";
export var backButton = "_1s-8";
export var clone = "_1s-e";
export var collapseBar = "_1s-j";
export var collapseMode = "_1s-l";
export var collapsed = "_1s-n";
export var dragHandle = "_1s-c";
export var dropdownIcon = "_1s-g";
export var expanding = "_1s-m";
export var hidden = "_1s-w";
export var iconContainer = "_1s-p";
export var iconSwapper = "_1s-v";
export var navItem = "_1s-6";
export var navItemIcon = "_1s-f";
export var navProfile = "_1s-7";
export var notificationCountBadge = "_1s-i";
export var notificationDot = "_1s-q";
export var optionsContainer = "_1s-h";
export var primaryNav = "_1s-0";
export var primaryNavDivider = "_1s-u";
export var primaryNavResizeHandle = "_1s-2";
export var primaryNavResizing = "_1s-1";
export var primaryNavTabSection = "_1s-t";
export var primaryTab = "_1s-o";
export var primaryTabIconBox = "_1s-r";
export var secondaryNav = "_1s-3";
export var selected = "_1s-s";
export var settingsNav = "_1s-4";
export var settingsNavItems = "_1s-5";
export var show = "_1s-d";
export var sideNav = "_1s-k";
export var teamItem = "_1s-a";
export var userProfileItem = "_1s-b";